import {faker} from 'services/fakeData'

export const LOCAL_PREFIX = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL ?? '' : 'https://silver-pact-230806.appspot.com'

const apiMethods = headers => ({
  get: path => faker(LOCAL_PREFIX + path, {headers: headers}),
  post: (path, body, stringify) => faker(LOCAL_PREFIX + path, {
    method: 'POST',
    headers: headers,
    body: stringify ? JSON.stringify(body) : body,
  }),
  patch: (path, body, stringify) => faker(LOCAL_PREFIX + path, {
    method: 'PATCH',
    headers: headers,
    body: stringify ? JSON.stringify(body) : body,
  }),
  delete: (path, body, stringify) => faker(LOCAL_PREFIX + path, {
    method: 'DELETE',
    headers: headers,
    body: stringify ? JSON.stringify(body) : body,
  }),
})

export const apiMethodsWithFingerprint = headers => ({
  get: path => apiMethods({...headers, 'device-id': apiMethodsWithFingerprint.fingerprint}).get(path),
  post: (path, body, stringify) => apiMethods({...headers, 'device-id': apiMethodsWithFingerprint.fingerprint}).post(path, body, stringify),
  patch: (path, body, stringify) => apiMethods({...headers, 'device-id': apiMethodsWithFingerprint.fingerprint}).patch(path, body, stringify),
  delete: (path, body, stringify) => apiMethods({...headers, 'device-id': apiMethodsWithFingerprint.fingerprint}).delete(path, body, stringify),
})

export const apiMethodsWithToken = headers => ({
  get: path => apiMethodsWithFingerprint({...headers, 'access-token': apiMethodsWithToken.token}).get(path),
  post: (path, body, stringify) => apiMethodsWithFingerprint({...headers, 'access-token': apiMethodsWithToken.token}).post(path, body, stringify),
  patch: (path, body, stringify) => apiMethodsWithFingerprint({...headers, 'access-token': apiMethodsWithToken.token}).patch(path, body, stringify),
  delete: (path, body, stringify) => apiMethodsWithFingerprint({...headers, 'access-token': apiMethodsWithToken.token}).delete(path, body, stringify),
})

const headersDefault = {
  'Content-Type': 'application/json',
}

export const publicApi = apiMethodsWithFingerprint(headersDefault)
export const api = apiMethodsWithToken(headersDefault)

export default api
